module.exports = __webpack_public_path__ + "img/topics5.db7d254d.png";